// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Style_toggle__1dYxu","dropdownMenu":"Style_dropdownMenu__TiW4t"};